<div class="modal-header">
  <h5 class="modal-title">{{ 'SectoralMeetings' | translate }} </h5>
  <button type="button" class="close" aria-label="Close" (click)="onCancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <form novalidate [formGroup]="sectoralMeetingForm">
        <div class="table-responsive">
          <table cdk-table #table matSort matSortDisableClear [dataSource]="sectoralMeetingDataSource"
            formArrayName="conventionRegistrationSectoralMeetings" class="table table-striped">

            <ng-container cdkColumnDef="selectItems">
              <th cdk-header-cell *cdkHeaderCellDef></th>
              <td cdk-cell *matCellDef="let element; let i = index;" [formGroupName]="i">
                <mrm-checkbox formControlName="selected" [showDisabled]="true"> </mrm-checkbox>
              </td>
            </ng-container>

            <ng-container cdkColumnDef="name">
              <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="name">{{'Name' | translate}}
              </th>
              <td cdk-cell *cdkCellDef="let element"> {{ element.value.name }} </td>
            </ng-container>

            <ng-container cdkColumnDef="startDate">
              <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="startDate" style="min-width: 115px;">
                {{'Date' | translate}}
              </th>
              <td cdk-cell *cdkCellDef="let element"> {{ element.value.startDate | dateFormat }} </td>
            </ng-container>

            <ng-container cdkColumnDef="room">
              <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="room">{{'Room' | translate}}
              </th>
              <td cdk-cell *cdkCellDef="let element"> {{element.value.room}} </td>
            </ng-container>

            <tr cdk-header-row *cdkHeaderRowDef="displayedColumns">
            </tr>
            <tr cdk-row *cdkRowDef="let row; columns: displayedColumns">
            </tr>
          </table>

        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="text-right">
    <div class="panel-footer pull-right">
      <button [disabled]="!canSubmit" [hidden]="readOnly" class="btn btn-primary" (click)="onSubmit()">{{
        'Submit' |
        translate }}</button>
      <button class="btn btn-secondary" (click)="onCancel()">{{ 'Cancel' | translate }}</button>
    </div>
  </div>
</div>